__turbopack_context__.v({
  "Separator": "LF-wWa_Separator",
  "connectButton": "LF-wWa_connectButton",
  "details": "LF-wWa_details",
  "editBtn": "LF-wWa_editBtn",
  "emptyData": "LF-wWa_emptyData",
  "expItem": "LF-wWa_expItem",
  "header": "LF-wWa_header",
  "label": "LF-wWa_label",
  "list": "LF-wWa_list",
  "logo": "LF-wWa_logo",
  "primaryLabel": "LF-wWa_primaryLabel",
  "primaryTeamBadge": "LF-wWa_primaryTeamBadge",
  "root": "LF-wWa_root",
  "row": "LF-wWa_row",
  "secondaryLabel": "LF-wWa_secondaryLabel",
  "tags": "LF-wWa_tags",
  "title": "LF-wWa_title",
});
